export const PURGE_AUTH = 'logOut';
export const TRY_AUTH = 'tryAuth';
export const SET_AUTH = 'setUser';
export const SET_USER_ROLE = 'setUserRole';